import { post, get, put, deleteApi } from '../axiosFun';
/* 学习记录 */
// 分页
const studyRecPage = data => {
  return post('/train/study-rec/page', data)
};
// 新增
const studyRecAdd = data => {
  return post('/train/study-rec-info/add', data)
};
// 导出
const studyRecExport = data => {
  return post('/train/study-rec/export', data, { responseType: 'blob', isExport: false })
};
// 学时统计
const studyTimesStatisticPage = (data,header) => {
  return post('/train/study-rec/studyTimesStatisticPage', data, header)
};
export default {
  studyRecPage,
  studyRecAdd,
  studyRecExport,
  studyTimesStatisticPage
}




// WEBPACK FOOTER //
// ./src/api/onlineTraining/studyRec.js